<script setup lang="ts">
import type { Question } from "~/features/python/ch2/exercise/types/exercise.types";

defineProps<{
  question: Question;
}>();
</script>

<template>
  <section class="rounded-3xl border border-emerald-200 bg-emerald-50 p-5 shadow-sm">
    <div class="space-y-1">
      <h2 class="text-lg font-semibold text-slate-900">Chalo step by step karte hain</h2>
      <p class="text-sm text-slate-600">Har step alag dikhaya gaya hai taake kuch bhi miss na ho.</p>
    </div>

    <ol class="mt-4 space-y-3 text-sm text-slate-700">
      <li
        v-for="(step, index) in question.solutionSteps"
        :key="`${question.id}-solution-${index}`"
        class="rounded-2xl bg-white p-4 ring-1 ring-emerald-100"
      >
        <span class="text-xs font-semibold uppercase tracking-wide text-emerald-700">Step {{ index + 1 }}</span>
        <p class="mt-2">{{ step }}</p>
      </li>
    </ol>

    <div class="mt-4 rounded-2xl bg-white p-4 ring-1 ring-emerald-100">
      <p class="text-xs font-semibold uppercase tracking-wide text-emerald-700">Akhri jawab</p>
      <p class="mt-2 text-sm font-medium text-slate-900">{{ question.finalAnswer || question.answer || question.correct }}</p>
    </div>
  </section>
</template>
